export * from './icon.component.js';
